import { useState, useCallback, useRef } from 'react';

import { Button, Tooltip, Tag, VSpacing, BottomSheet, BottomSheetFooter } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { useVacancyIdNonNullable } from 'src/components/ResumeCard/hooks/useVacancyId';
import translation from 'src/components/translation';

import styles from './index.less';

const TrlKeys = {
    tag: 'employer.vacancyResponses.badge.chat',
    dropInfo: 'employer.vacancyResponses.badge.chat.infotip.text',
    dropInfoButtonSetup: 'employer.vacancyResponses.badge.chat.infotip.setup',
    dropInfoButtonDetails: 'employer.vacancyResponses.badge.chat.infotip.details',
};

const FromChat: TranslatedComponent = ({ trls }) => {
    const [showDropDown, setShowDropInfo] = useState(false);
    const vacancyId = useVacancyIdNonNullable();
    const activatorRef = useRef<HTMLSpanElement>(null);

    const handleOpenDropInfo = useCallback(() => {
        setShowDropInfo(true);
    }, [setShowDropInfo]);

    const handleCloseDropInfo = useCallback(() => {
        setShowDropInfo(false);
    }, [setShowDropInfo]);

    const tooltipLeftButtonProps = {
        'data-qa': 'response_badge_from_call_callpage_link',
        Element: SPALink,
        to: `/employer/vacancy/edit/${vacancyId}?step=1`,
        target: '_blank',
    };

    const tooltipRightButtonProps = {
        'data-qa': 'response_badge_from_chat_article_link',
        Element: SPALink,
        to: 'https://special.hh.ru/otklik_iz_chata',
        target: '_blank',
    };

    return (
        <>
            <span
                data-qa="response_badge_from_chat"
                onClick={handleOpenDropInfo}
                className={styles.tagClickable}
                data-interactive
                ref={activatorRef}
            >
                <Tag style="special">{trls[TrlKeys.tag]}</Tag>
            </span>
            <Tooltip
                placement="top-center"
                visible={showDropDown}
                showClose
                aria-label-close="close"
                onClose={handleCloseDropInfo}
                activatorRef={activatorRef}
            >
                {trls[TrlKeys.dropInfo]}
                <VSpacing default={12} />
                <div className={styles.tagTooltipButtonsWrapper}>
                    <Button mode="secondary" style="contrast" {...tooltipLeftButtonProps}>
                        {trls[TrlKeys.dropInfoButtonSetup]}
                    </Button>
                    <Button mode="tertiary" style="contrast" {...tooltipRightButtonProps}>
                        {trls[TrlKeys.dropInfoButtonDetails]}
                    </Button>
                </div>
            </Tooltip>
            <BottomSheet
                visible={showDropDown}
                onClose={handleCloseDropInfo}
                footer={
                    <BottomSheetFooter>
                        <Button mode="primary" style="accent" {...tooltipLeftButtonProps} stretched>
                            {trls[TrlKeys.dropInfoButtonSetup]}
                        </Button>
                        <Button mode="secondary" style="accent" {...tooltipRightButtonProps} stretched>
                            {trls[TrlKeys.dropInfoButtonDetails]}
                        </Button>
                    </BottomSheetFooter>
                }
            >
                {trls[TrlKeys.dropInfo]}
            </BottomSheet>
        </>
    );
};

export default translation(FromChat);
